"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationType = void 0;
var LocationType;
(function (LocationType) {
    LocationType["CITY"] = "CITY";
})(LocationType || (exports.LocationType = LocationType = {}));
//# sourceMappingURL=LocationDto.js.map